import { VisualizerRightPanel } from "./visualizer-right-panel-container";

export default VisualizerRightPanel;